export * from './lib/global.module';
export { ConfigService } from './lib/services/config/config.service';
export { CommunicationConfigService } from './lib/services/communication-config/communication-config.service';
export { CustomValidatorsService } from './lib/services/custom-validators/custom-validators.service';
export { ToolsService } from './lib/services/tools/tools.service';
export { CsrfService } from './lib/services/csrf/csrf.service';
export { IsSigninService } from './lib/services/is-signin/is-signin.service';
export { MainConfigService } from './lib/services/main-config/main-config.service';

import * as Stepper from './lib/components/kendo-stepper/kendo-step/stepper-host.directive';
import * as StepperInterface from './lib/components/kendo-stepper/kendo-step/stepper-step.i';

/* HELPER */
export * from './lib/helpers/component-helper';

export namespace MStepper {
  export import StepperDirective = Stepper.StepperDirective;
  export import IStepComponent = StepperInterface.IStepComponent;
  export import IStep = StepperInterface.IStep;
}
